import { render, staticRenderFns } from "./AccettazioneRicettaPrestazioniListaPage.vue?vue&type=template&id=636d4085&scoped=true"
import script from "./AccettazioneRicettaPrestazioniListaPage.vue?vue&type=script&lang=js"
export * from "./AccettazioneRicettaPrestazioniListaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636d4085",
  null
  
)

export default component.exports